module.exports = __webpack_public_path__ + "img/sec2_5_m.32eeb1c9.png";